import { ArrowClockwise, ArrowCounterClockwise, Export, Trash } from "@phosphor-icons/react";
import { useMeasurement } from "../../providers/NewMeasurementProvider";

export function Toolbar() {
  const { undoLastMeasurementChange, deleteAllMeasurements } = useMeasurement();

  return (
    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-30 backdrop-filter backdrop-blur-lg p-2 rounded-full shadow-md z-10 flex items-center">
      <button
        className="mx-2 p-2 bg-gradient-to-r from-red-400 to-red-600 text-white rounded-full shadow-lg hover:from-red-500 hover:to-red-700 transition duration-300"
        onClick={deleteAllMeasurements}
      >
        <Trash weight='duotone' size={24} />
      </button>

      <div className="w-px h-6 bg-gray-400 mx-2"></div> {/* Divider */}

      <button
        className="mx-2 p-2 bg-gradient-to-r from-indigo-400 to-indigo-600 text-white rounded-full shadow-lg hover:from-indigo-500 hover:to-indigo-700 transition duration-300"
        onClick={undoLastMeasurementChange}
      >
        <ArrowCounterClockwise weight='duotone' size={24} />
      </button>
      <button
        className="mx-2 p-2 bg-gradient-to-r from-indigo-400 to-indigo-600 text-white rounded-full shadow-lg hover:from-indigo-500 hover:to-indigo-700 transition duration-300"

      >
        <Export weight='duotone' size={24} />
      </button>

      <div className="w-px h-6 bg-gray-400 mx-2"></div> {/* Divider */}

    </div>
  )
}